module.exports = __webpack_public_path__ + "img/wallet_02_cross_1.4b1eaaf5.png";